import Cookies from 'universal-cookie';
import { FormSchema } from '../../page/components/SubscriptionDrawer/schema';

// Local storage keys

const STORAGE_PREFIX = 'reselling_listing_page';

export const getSelectedCountryStorageKey = (sellerName: string) => `${STORAGE_PREFIX}.${sellerName}.selected_country`;

// Cookies storage keys

export const getIsSubscriptionDrawerOpenCookieName = (sellerName: string): string =>
    `${STORAGE_PREFIX}.${sellerName}.subscription_drawer_is_open`;

export const getSubscriptionDrawerFormDataCookieName = (sellerName: string) =>
    `${STORAGE_PREFIX}.${sellerName}.subscription_drawer_form_data`;

// cookies
export const setSubscriptionDrawerIsOpenCookie = (sellerName: string) => {
    const cookieName = getIsSubscriptionDrawerOpenCookieName(sellerName);
    const isOpen = 'true';

    const cookies = new Cookies();
    cookies.set(cookieName, isOpen, {
        secure: true,
        sameSite: 'lax',
        maxAge: 60 * 60, // 1hr
        path: window.location.pathname,
    });
};

export const removeSubscriptionDrawerIsOpenCookie = (sellerName: string) => {
    const cookieName = getIsSubscriptionDrawerOpenCookieName(sellerName);

    const cookies = new Cookies();
    cookies.remove(cookieName, { path: window.location.pathname });
};

export const setSubscriptionFormDataCookie = (sellerName: string, formData: FormSchema) => {
    const cookieName = getSubscriptionDrawerFormDataCookieName(sellerName);

    const cookies = new Cookies();
    cookies.set(cookieName, formData, {
        secure: true,
        sameSite: 'lax',
        maxAge: 60 * 60, // 1hr
        path: window.location.pathname,
    });
};

export const getSubscriptionFormDataCookie = (sellerName: string): FormSchema => {
    const cookieName = getSubscriptionDrawerFormDataCookieName(sellerName);

    const cookies = new Cookies();
    return cookies.get(cookieName);
};

export const removeSubscriptionFormDataCookie = (sellerName: string) => {
    const cookieName = getSubscriptionDrawerFormDataCookieName(sellerName);

    const cookies = new Cookies();
    cookies.remove(cookieName, { path: window.location.pathname });
};
